import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import "./Navbar.css";

export default function App() {
  return (
    <>
      <Navbar bg="dark" variant="dark" className="Navigation-bar">
        <Navbar.Toggle />
        <Navbar.Collapse>
          <Nav className="mr-auto" id="navbar-text" >
            <Navbar.Brand href="#home" className="Name">Laura Vavasseur</Navbar.Brand>
            
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
}